export default ({ Schema }) => {
  const AlternativeSchema = new Schema({
    text: { type: String, required: true },
    weight: { type: Number, required: true, default: 0, min: 0, max: 100 },
    invalidatePDV: {
      type: Boolean,
      validate: {
        validator(v) {
          return !v || !this.weight
        },
        message: 'A correct alternative cannot invalidate a PDV',
      },
    },
    detailOptions: { type: [String], default: null },
    invalidateCoaching: { type: Boolean, default: false },
  })

  const QuestionSchema = new Schema({
    text: { type: String, required: true },
    questionType: {
      type: String,
      required: true,
      enum: ['radio', 'check', 'text', 'number'],
    },
    steps: { type: [String], default: () => [] },
    alternatives: { type: [AlternativeSchema], default: () => null },
    skipEvaluation: { type: Boolean, default: false },
    weight: { type: Number, required: true, default: 0, min: 0, max: 100 },
    answer: { type: [String], default: () => null },
  })

  const FormSchema = new Schema({
    title: { type: String, required: true },
    description: { type: String, default: '' },
    stage: {
      type: String,
      required: true,
      enum: ['pre-process', 'process', 'post-process'],
    },
    targetAudience: {
      type: String,
      default: 'field',
      enum: ['field', 'teleSales'],
    },
    segments: { type: [String], default: () => [] },
    active: { type: Boolean, default: true },
    permissions: {
      coach: { type: [String] },
      coachee: { type: [String] },
    },
    questions: { type: [QuestionSchema], default: [] },
    newForm: { type: Boolean, required: true, default: false },
  })

  FormSchema.index({
    segments: 'text',
    title: 'text',
    description: 'text',
    stage: 'text',
  })
  return FormSchema
}
